import { render, staticRenderFns } from "./LoanTransactionView.vue?vue&type=template&id=3f0fd0f0"
import script from "./LoanTransactionView.vue?vue&type=script&lang=js"
export * from "./LoanTransactionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports